import { render, staticRenderFns } from "./SubBranchPicker.vue?vue&type=template&id=23d8bfb5&scoped=true&"
import script from "./SubBranchPicker.vue?vue&type=script&lang=js&"
export * from "./SubBranchPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d8bfb5",
  null
  
)

export default component.exports